<template>
  <div>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="图片(760*814)" >
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.coverPath"
          :imageUrl="form.data.coverPath"
          :options="coverOptions"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>

    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!gatherId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="gatherId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
  </div>
</template>

<script>
import {
  _queryGoodsSeriesGather,
  _addGoodsSeriesGather,
  _updateGoodsSeriesGather,
} from '@/api/websiteGoodsSeriesGatherApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getInspiration() {
  const result = await _queryGoodsSeriesGather(this.gatherId);
  if (result) {
    this.form.data.type = result.type;
    this.form.data.coverPath = result.coverPath;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsSeriesGather({
        coverPath: this.form.data.coverPath,
        seriesId: this.seriesId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}
function reviewVideo() {
  if (this.form.data.inspirationVideo) {
    this.video.visible = true;
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsSeriesGather(this.gatherId, {
        coverPath: this.form.data.coverPath,
        seriesId: this.seriesId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsSeriesGatherEdit',
  components: {
    CropperUploader,
    // SimpleUploader,
  },
  props: {
    gatherId: String,
    seriesId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  // watch: {
  //   gatherId() {
  //     if (this.gatherId) {
  //       this.getInspiration();
  //     }
  //   },
  // },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getInspiration,
    reviewVideo,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 760, // 默认生成截图框宽度
        autoCropHeight: 814, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      form: {
        data: {
          coverPath: '',
        },
        rules: {
        },
        title: '',
      },
    };
  },
  created() {
    if (this.gatherId) {
      this.getInspiration();
    }
  },
};
</script>
